<app-project-discussion-chat-header
  [entry]="reply"
></app-project-discussion-chat-header>
{{reply?.comment}}
<app-project-discussion-chat-controls
  [entry]="reply"
  [project]="project"
  [updateOnly]="true"
></app-project-discussion-chat-controls>
